export default {"src":"/_next/static/media/icon-fuel.e7199beb.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};